import { isVisible } from './various.js';

export default function () {
    document.querySelectorAll('.order-state-changer h3').forEach(item => {
        item.addEventListener('click', function () {
            this.classList.toggle('active');
        });
    });

    document.addEventListener('mouseup', function (event) {
        const elements = document.querySelectorAll('.order-state-changer');

        elements.forEach(elem => {
            if (!elem.contains(event.target) && isVisible(elem)) {
                elem.querySelector('h3').classList.remove('active');
            }
        });
    });
}